// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/Settings.css
// module id = 180
// module chunks = 0